import React , { useState } from "react";
import _ from "lodash";
// reactstrap components
import {
    Card,
    CardHeader,
    CardBody,
    Row,
    Col
} from "reactstrap";
// core components
import { withTranslation } from "react-i18next";
import { useForm } from "react-hook-form"
// import CommonFields from "../fields/shared/CommonFields";
import UnitFields from "../fields/";
import UIDs from "../../../../UIDs";
//import { helpers } from "chart.js";
import { ImageField } from "../fields/types";
import MessageBox from "../../../../components/ui/MessageBox";
import { Sticky } from "react-sticky";
import { LocalizableTextField } from "../fields/types";
import * as Helper from "../../../../utils/Helper";

const uid = UIDs.screens.admin.unit.forms.unitform;

let t;

const UnitForm = (props) => {
    t = props.t;

    //form hook helper func
    const formMethods = useForm();
    if (!formMethods.oldSetValue) {
        // hook setValue方法, 当组件调用setValue设置表单数据时, 能通知外部数据已更新
        formMethods.onChange = props.onChange;
        formMethods.oldSetValue = formMethods.setValue;
        formMethods.setValue = (key, value) => {
            formMethods.oldSetValue(key, value);
            if (props.onChange) {
                props.onChange();
            }
        };
    }

    const { unitType, formData, commonFieldValues, id } = props.data;
    if (props.onForm) {
        props.onForm(id, formMethods);
    }

    const isCompositeUnit = ('CP' === unitType);
    const EditFields = UnitFields[unitType];

    const onSave = newFormData => {
        var buildFieldsData = EditFields.buildFieldsData;
        if (!buildFieldsData) {
            // due to translation wrapper
            buildFieldsData = EditFields.WrappedComponent.buildFieldsData;
        }

        let fieldsData = {};
        try {
            fieldsData = buildFieldsData(newFormData)
        } catch (e) {
            MessageBox.danger({ text: e.message, duration: 5000 });
            return;
        }

        if (fieldsData.data && _.isPlainObject(fieldsData.data)){
            if (!isCompositeUnit) {
                fieldsData.data = {
                    ...fieldsData.data,
                    title: Helper.combineTranslation(newFormData, "title"),
                }
            }
        }

        let duration = newFormData.duration;
        if (isCompositeUnit) {
            // 复合单元duration为所有子单元的duration相加
            duration = 0;
            fieldsData.data.units.forEach((subUnit) => {
                duration += parseInt(subUnit.duration);
            });
        }

        let submitData = {
            ...fieldsData,
            commonFieldValues: {
                duration: duration,
                cover: newFormData.cover,
            }
        }

        props.onSave(submitData);
    };

    const onSaveAndCreate = newFormData => {
        var buildFieldsData = EditFields.buildFieldsData;
        if (!buildFieldsData) {
            // due to translation wrapper
            buildFieldsData = EditFields.WrappedComponent.buildFieldsData;
        }

        let fieldsData = {};
        try {
            fieldsData = buildFieldsData(newFormData)
        } catch (e) {
            MessageBox.danger({ text: e.message, duration: 5000 });
            return;
        }

        if (fieldsData.data && _.isPlainObject(fieldsData.data)){
            fieldsData.data = {
                ...fieldsData.data,
                title: Helper.combineTranslation(newFormData, "title"),
            }
        }

        let submitData = {
            ...fieldsData,
            commonFieldValues: {
                duration: newFormData.duration,
                cover: newFormData.cover,
            }
        }

        props.onSaveAndCreate(submitData);
    };
    
    const { hotkeysHandler } = props;

    const formHotKeysHandler = e => {
        e = e || window.event;
        if (e.keyCode === 83 && e.altKey) {//alt+s,alt+S
            formMethods.handleSubmit(onSave)()
        }
        if (e.keyCode === 67 && e.altKey) {//alt+s,alt+S
            formMethods.handleSubmit(onSaveAndCreate)()
        }
        if (e.keyCode === 82 && e.altKey) {//alt+r,alt+R
            formMethods.reset()
        }
        if (e.keyCode === 81 && e.altKey) {//alt+q,alt+Q
            hotkeysHandler.CANCEL();
        }
    };

    const bindHotkeys = setInterval(() => {
        const unitForm = document.getElementById("unitForm");
        if (unitForm) {
            const inputs = unitForm.querySelectorAll("input,textarea");
            Array.from(inputs).map(e => e.onkeydown = formHotKeysHandler)
            clearInterval(bindHotkeys);
        }
    }, 100);

    window.onkeydown = formHotKeysHandler;

    const [state_hideHeader, setstate_hideHeader] = useState(false);

    return (
        <form id="unitForm" onChange={props.onChange}>
            <Card className="shadow">
                {state_hideHeader || props.noHeader ? null :
                <CardHeader className="bg-white border-0" style={{ zIndex: 1 }}>
                    <Sticky>
                        {({
                            style,
                            distanceFromTop
                        }) => (
                                <div style={style}>
                                    <div className="align-items-center" style={{
                                        height: "100%",
                                        background: "#ffffff",
                                        borderBottom: `${distanceFromTop && distanceFromTop <= 0 ? "1px solid #E4E4E4" : "1px solid #ffffff"}`
                                    }}
                                    >
                                        <Row>
                                            <Col xs="6" style={{ marginTop: distanceFromTop && distanceFromTop <= 0 ? 20 : 0, marginBottom: distanceFromTop && distanceFromTop <= 0 ? 20 : 0 }}>
                                                <h3 className="mb-0">{unitType + " " + props.t("unit")}</h3>
                                            </Col>
                                            <Col className="text-right" xs="6" style={{ marginTop: distanceFromTop && distanceFromTop <= 0 ? 20 : 0, marginBottom: distanceFromTop && distanceFromTop <= 0 ? 20 : 0 }}>
                                                <button type="submit" className="btn btn-info btn-sm" onClick={formMethods.handleSubmit(onSave)}>{props.t("save") + "(S)"}</button>
                                                &nbsp;
                                                {
                                                    !id && props.onSaveAndCreate ? (<button type="submit" className="btn btn-success btn-sm" onClick={formMethods.handleSubmit(onSaveAndCreate)}>{props.t("saveandcreate") + "(C)"}</button>) : null
                                                }
                                                &nbsp;
                                                <button type="reset" className="btn btn-default btn-sm">{props.t("reset") + "(R)"}</button>
                                                &nbsp;
                                                <button type="button" className="btn btn-default btn-sm" onClick={props.onCancel}>{props.t("cancel") + "(Q)"}</button>
                                            </Col>
                                        </Row>
                                    </div>
                                </div>
                            )}
                    </Sticky>
                </CardHeader>}
                <CardBody>
                    {state_hideHeader ? null :
                     <Row>
                         <Col>
                             <CommonFields formMethods={formMethods} values={commonFieldValues} resourceId={props.resourceId} isCompositeUnit={isCompositeUnit} />
                         </Col>
                     </Row>}
                    <EditFields formMethods={formMethods} data={formData} resourceId={props.resourceId}
                                isSimpleBatchForm={false} onHideHeader={(hide) => setstate_hideHeader(hide)}/>
                </CardBody>
            </Card>
        </form>
    );
}

function CommonFields({ formMethods, values, resourceId, isCompositeUnit }) {
    const { register, errors, clearError } = formMethods
    const { duration, cover, title, renderCover } = values;
    const fieldsForImage = {
        imagePath: { name: "cover", value: cover, label: t("cover") },
        registerPayload: { required: false }
    }

    const fieldsForTitle = {
        text: {
            name: "title", label: t("title"), value: title,
            registerPayload: {
                required: false
            }
        },
    };

    if (isCompositeUnit) {
        return (
            <>
                {renderCover 
                 ? renderCover()
                 : <ImageField formMethods={formMethods} resourceId={resourceId} fields={fieldsForImage} />
                }
                <Row>
                    <Col>
                        <div className="form-group">
                            <label className="form-control-label">{t("durationLabel")} <small>({t("durationDesc")})</small></label>
                            <div className="form-control-alternative form-control">
                                {duration}
                            </div>
                        </div>
                    </Col>
                </Row>
            </>);
    }
    return (        
        <>  
            {renderCover 
                ? renderCover()
                : <ImageField formMethods={formMethods} resourceId={resourceId} fields={fieldsForImage} />
            }  
            <Row>
                <Col>
                    <div className="form-group">
                        <label className="form-control-label">{t("durationLabel")} <small>({t("durationDesc")})</small></label>
                        <input name="duration" type="text" className="form-control-alternative form-control"
                            defaultValue={duration}
                            ref={register({
                                required: true,
                                validate: {
                                    message: value => {
                                        if (!_.isNumber(value)) {
                                            value = _.toNumber(value);
                                            if (value < 0 || isNaN(value))
                                                return t("shouldLargerThanZero");
                                        }
                                        return clearError();
                                    }
                                }
                            })}
                        />
                        {errors.duration && <span className="text-danger">{errors.duration.message || t("fieldIsRequired")}</span>}
                    </div>
                </Col>
            </Row>
            <Row style={{ marginBottom: 20 }}>
                <Col>
                    <LocalizableTextField formMethods={formMethods} fields={fieldsForTitle} />
                </Col>
            </Row>
        </>
    );
}

export default withTranslation(uid)(UnitForm);
